import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 7" {...props}><path d="M.684.055l2.92 2.988a.234.234 0 010 .32L.683 6.351a.216.216 0 01-.31 0l-.31-.32a.234.234 0 010-.321l2.298-2.347a.234.234 0 000-.32L.078.696a.234.234 0 010-.32l.31-.321a.228.228 0 01.296 0z" /></svg>);